export default __webpack_public_path__ + "static/media/index-pointing-up.8c87485e.png";